import { createQuery } from '@amzn/gsce-shared-react-lib';
import {
  GetAuditSummaryCommand,
  type GetAuditSummaryCommandInput,
} from '@amzn/gbsa-helios-typescript-client';
import { apiHeliosClient, withRetry } from '../../../shared/data';
import { AuditQueryKeys } from './keys';

/**
 * Fetches audit summary (metadata + questions) for a single audit.
 *
 * Uses createQuery from GsceSharedReactLib — cache key is auto-mapped
 * as ['audit-summary', input]. Caller must pass `{ enabled }` to control
 * when the query fires.
 */
export const useAuditSummaryQuery = createQuery(
  AuditQueryKeys.summary,
  (input: GetAuditSummaryCommandInput) =>
    withRetry(() => apiHeliosClient.send(new GetAuditSummaryCommand(input))),
);
